import {
  AuthenticateNoltReq,
  AuthenticateNoltRes,
  AuthenticateOneTimePasswordReq,
  AuthenticateOneTimePasswordRes,
  AuthenticateWebAuthnMultiUserStartReq,
  AuthenticateWebAuthnMultiUserStartRes,
  AuthenticateWebAuthnReq,
  AuthenticateWebAuthnRes,
  AuthenticateWebAuthnStartReq,
  AuthenticateWebAuthnStartRes,
  ExtendSessionReq,
  ExtendSessionRes,
  RegisterWebAuthnReq,
  RegisterWebAuthnRes,
  RegisterWebAuthnStartReq,
  RegisterWebAuthnStartRes,
  RevokeSessionReq,
  RevokeSessionRes,
  SendOneTimePasswordEmailReq,
  SendOneTimePasswordEmailRes,
  SendOneTimePasswordSMSReq,
  SendOneTimePasswordSMSRes,
} from "gen/api/auth/service_pb"
import { AuthServiceClient } from "gen/api/auth/service_pb.client"

import { apiSlice, transport } from "./apiSlice"

const c = new AuthServiceClient(transport)

export const authApiSlice = apiSlice
  .enhanceEndpoints({
    addTagTypes: ["Staff", "Flags"],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      registerWebAuthnStart: builder.mutation<
        RegisterWebAuthnStartRes,
        RegisterWebAuthnStartReq
      >({
        query: (r) => c.registerWebAuthnStart({ ...r }),
      }),
      registerWebAuthn: builder.mutation<
        RegisterWebAuthnRes,
        RegisterWebAuthnReq
      >({
        query: (r) => c.registerWebAuthn(r),
        invalidatesTags: ["Staff"],
      }),
      authenticateWebAuthnStart: builder.mutation<
        AuthenticateWebAuthnStartRes,
        AuthenticateWebAuthnStartReq
      >({
        query: (r) => c.authenticateWebAuthnStart({ ...r }),
      }),
      authenticateWebAuthnMultiUserStart: builder.mutation<
        AuthenticateWebAuthnMultiUserStartRes,
        AuthenticateWebAuthnMultiUserStartReq
      >({
        query: (r) => c.authenticateWebAuthnMultiUserStart({ ...r }),
      }),
      authenticateWebAuthn: builder.mutation<
        AuthenticateWebAuthnRes,
        AuthenticateWebAuthnReq
      >({
        query: (r) => c.authenticateWebAuthn(r),
        invalidatesTags: ["Flags"],
      }),
      sendOneTimePasswordSMS: builder.mutation<
        SendOneTimePasswordSMSRes,
        SendOneTimePasswordSMSReq
      >({
        query: (r) => c.sendOneTimePasswordSMS(r),
      }),
      sendOneTimePasswordEmail: builder.mutation<
        SendOneTimePasswordEmailRes,
        SendOneTimePasswordEmailReq
      >({
        query: (r) => c.sendOneTimePasswordEmail(r),
      }),
      authenticateOneTimePassword: builder.mutation<
        AuthenticateOneTimePasswordRes,
        AuthenticateOneTimePasswordReq
      >({
        query: (r) => c.authenticateOneTimePassword(r),
        invalidatesTags: ["Flags"],
      }),
      extendSession: builder.mutation<ExtendSessionRes, ExtendSessionReq>({
        query: (r) => c.extendSession(r),
      }),
      revokeSession: builder.mutation<RevokeSessionRes, RevokeSessionReq>({
        query: (r) => c.revokeSession(r),
        invalidatesTags: ["Flags"],
      }),
      authenticateNolt: builder.query<AuthenticateNoltRes, AuthenticateNoltReq>(
        {
          query: (r) => c.authenticateNolt(r),
        }
      ),
    }),
  })

export const {
  useRegisterWebAuthnStartMutation,
  useRegisterWebAuthnMutation,
  useAuthenticateWebAuthnStartMutation,
  useAuthenticateWebAuthnMultiUserStartMutation,
  useAuthenticateWebAuthnMutation,
  useSendOneTimePasswordSMSMutation,
  useSendOneTimePasswordEmailMutation,
  useAuthenticateOneTimePasswordMutation,
  useExtendSessionMutation,
  useRevokeSessionMutation,
  useAuthenticateNoltQuery,
} = authApiSlice
